import React, { useMemo, useRef } from 'react'
import Box from '@mui/material/Box'
import Drawer from '@mui/material/Drawer'
import CssBaseline from '@mui/material/CssBaseline'
import AppBar from '@mui/material/AppBar'
import List from '@mui/material/List'
import Typography from '@mui/material/Typography'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import category from 'shared/assets/icons/Category.svg'
import device from 'shared/assets/icons/device-message.svg'
import deviceactive from 'shared/assets/icons/device-messageactive.svg'
import settings from 'shared/assets/icons/Setting.svg'
import settingactive from 'shared/assets/icons/Settingactive.svg'
import profileSelectIcon from 'shared/assets/icons/profile-select.svg'
import profileIcon from 'shared/assets/icons/profile-simple.svg'
import categoryMobactive from 'shared/assets/icons/category-2.svg'
import profileIconactive from 'shared/assets/icons/profile-active.svg'
import settingMobactive from 'shared/assets/icons/setting-2.svg'
import shoppingCartactive from 'shared/assets/icons/shopping-cart.svg'
import backgroundmob from '../../assets/images/Bgmob.jpg'
import backgroundretail from '../../assets/images/BGUserWeb.jpg'
import backgroundmobretail from '../../assets/images/BgUserMob.jpg'
import categoryactive from 'shared/assets/icons/Categoryactive.svg'
import subscription from 'shared/assets/icons/subscription.svg'
import subscriptionactive from 'shared/assets/icons/subscriptionactive.svg'
import logo from 'shared/assets/icons/logos/mePrismPrivacy.svg'
import BottomNavigation from '@mui/material/BottomNavigation'
import BottomNavigationAction from '@mui/material/BottomNavigationAction'
import {
  Button,
  Collapse,
  Link,
  ThemeProvider,
  useMediaQuery,
} from '@mui/material'
import { fonts, theme } from '../../theme/DashboardTheme'
import { useNavigate, useLocation, Outlet, useOutletContext } from 'react-router-dom'
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { useAppDispatch, useAppSelector } from '../../redux/storeExports'
import { logOutUser } from '../../redux/authentication/AuthenticationSlice'
import { selectActiveGrant } from '../../redux/product/ProductSlice'

// import { CorporateProfileSelector } from '../../redux/CorporateProfile/CorporateProfileSlice'

const styles = {
  linkStyle: {
    margin: '0',
    fontFamily: 'InterMedium',
    fontSize: '0.875rem !important',
    lineHeight: '1.5',
    color: '#1a1b20',
    fontWeight: '400',
  },
  subscribeDiv: {
    margin: 5,
    borderRadius: '16px',
    padding: 5,
    background:
      'linear-gradient(102.89deg, #708FF4 9.09%, #426BF0 69.63%), linear-gradient(0deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.15))',
  },
  subscribeText: {
    color: 'white !important',
  },
  subscribeButton: {
    marginBlock: '0.5rem',
    background: 'white',
    color: 'rgba(66, 107, 240, 1) !important',
    '&:hover': {
      background: 'white',
      color: 'rgba(66, 107, 240, 1) !important',
    },
  },
}

const sidebarnewItems = [
  {
    id: 'dashboard',
    icon: <img src={category} alt="relatives" width={38} height={38} />,
    iconactive: <img src={categoryactive} alt="relatives" width={38} height={38} />,
    text: 'Dashboard',
    url: '/dashboard',
  },
  {
    id: 'profile',
    icon: <img src={profileIcon} alt="relatives" width={38} height={38} />,
    iconactive: <img src={profileSelectIcon} alt="relatives" width={38} height={38} />,
    text: 'Profile',
    url: '/dashboard/profile',
  },
  {
    id: 'Settings',
    icon: <img src={settings} alt="relatives" width={38} height={38} />,
    iconactive: <img src={settingactive} alt="relatives" width={38} height={38} />,
    text: 'Settings',
    url: '/settings',
  },
  {
    id: 'Subscription',
    icon: <img src={subscription} alt="relatives" width={38} height={38} />,
    iconactive: <img src={subscriptionactive} alt="relatives" width={38} height={38} />,
    text: 'Subscription',
    url: '/subscription',
  },
  {
    id: 'help',
    icon: <img src={device} alt="relatives" width={38} height={38} />,
    iconactive: <img src={deviceactive} alt="relatives" width={38} height={38} />,
    text: 'Help & Support',
    url: '/dashboard/help-support',
    submenu: [
      { id: 'FAQs', text: 'FAQs', url: 'https://meprism.com/faqs' },
      {
        id: 'CustomerSupport',
        text: 'Customer Support',
        url: 'https://meprism1.atlassian.net/servicedesk/customer/portal/1',
      },
    ],
  },
]
export default function SidebarNavigation() {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const grant = useAppSelector(selectActiveGrant)

  const sidebarMobItems = [
    {
      id: 'dashboard',
      icon: <img src={category} alt="dashboard" width={28} height={28} />,
      iconactive: <img src={categoryMobactive} alt="dashboard" width={24} height={24} />,
      text: 'Dashboard',
      url: '/dashboard',
    },
    {
      id: 'profile',
      icon: <img src={profileIcon} alt="profile" width={28} height={28} />,
      iconactive: <img src={profileIconactive} alt="profile" width={24} height={24} />,
      text: 'Profile',
      url: '/dashboard/profile',
    },
    {
      id: 'Settings',
      icon: <img src={settings} alt="settings" width={28} height={28} />,
      iconactive: <img src={settingMobactive} alt="settings" width={24} height={24} />,
      text: 'Settings',
      url: '/settings',
    },
    {
      id: 'Subscription',
      icon: <img src={subscription} alt="subscription" width={28} height={28} />,
      iconactive: <img src={shoppingCartactive} alt="subscription" width={24} height={24} />,
      text: 'Subscription',
      url: '/subscription',
    },
    {
      id: 'help',
      icon: <img src={device} alt="help" width={28} height={28} />,
      iconactive: <img src={deviceactive} alt="help" width={24} height={24} />,
      text: 'Help',
      url: 'https://meprism.com/faqs',
      external: true,
    },
  ]
  const [open, setOpen] = React.useState(!isMobile)

  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const location = useLocation() || { pathname: '' } // Handle possible null value

  const [isDropdownOpen, setDropdownOpen] = React.useState(false)

  const toggleDropdown = () => {
    setOpen(false)
    setDropdownOpen(!isDropdownOpen)
  }

  const handleLogout = async () => {
    await dispatch(logOutUser()).unwrap()
    navigate('/login/signin')
  }
  const activeGrant = useAppSelector(selectActiveGrant)
  const selectedItem = useMemo(() => {
    const lastPartOfUrl = location.pathname.split('/').pop()?.toLowerCase()
    const currentPath = location.pathname.toLowerCase()

    const currentSidebarItem = sidebarnewItems.find((item) => {
      // Handle submenu items
      if (item.submenu) {
        return item.submenu.some(
          (subItem) => subItem.url.toLowerCase() === currentPath,
        )
      }
      // Special case for Settings: match if path starts with /settings
      if (item.id === 'Settings' && currentPath.startsWith('/settings')) {
        return true
      }
      // Default: match by last part of URL
      return item.id.toLowerCase() === lastPartOfUrl
    })

    return currentSidebarItem ? currentSidebarItem.id : null
  }, [location.pathname])

  const handleItemClick = (itemId: string, url: string, external?: boolean) => {
    if (external || itemId === 'FAQs' || itemId === 'CustomerSupport') {
      window.open(url, '_blank')
    } else if (location.pathname === url) {
      // Prevent redundant navigation if already on the same URL
      return
    } else {
      navigate(url)
    }
  }

  const handleDrawerToggle = () => {
    if (rootRef.current) {
      setOpen((prevOpen) => !prevOpen)
    }
  }
  const rootRef = useRef(null)

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: 'flex', flexDirection: 'column' }} ref={rootRef}>
        <CssBaseline />
        {!isMobile && (
          <AppBar
            sx={{
              position: 'absolute',
              background: 'transparent',
              boxShadow: 'none',
              p: 4,
            }}
          >
            <Box
              sx={{
                pr: '24px',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              {/* Desktop header content if any */}
            </Box>
          </AppBar>
        )}
        <Box display={'flex'}>
          <Drawer
            variant={isMobile ? 'temporary' : 'permanent'}
            onClick={handleDrawerToggle}
            sx={{
              width: 274,
              overflowY: 'auto',
              '& .MuiDrawer-paper': {
                width: isMobile ? '80%' : 274, // Adjust the paper width
                maxWidth: isMobile ? '80%' : 274, // Adjust the maximum paper width
              },
            }}
            open={open}>
            <Box
              sx={{
                margin: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                px: [1],
              }}>
              {' '}
              {/* Adjust the margin value as needed */}
              <img src={logo} alt="Logo" width={isMobile ? "70%" : "90%"} height="95%" />
            </Box>

            {sidebarnewItems.map((item, index) => (
              <div key={item.id}>
                {index === 4 ? (
                  <div>
                    <ListItem
                      disablePadding
                      onClick={toggleDropdown}
                      sx={{
                        color:
                          selectedItem === item.id
                            ? activeGrant &&
                              activeGrant?.grant_source === 'corporate_grant'
                              ? '#9135E0'
                              : '#C67EFF'
                            : 'inherit',
                        fontFamily: fonts.Inter.Medium,
                      }}>
                      <ListItemButton
                        sx={{
                          padding: '8px 0px',
                          marginX: 6,
                          borderRadius: 3,
                          maxHeight: '50px',
                          background:
                            selectedItem === item.id
                              ? '#9135E0'
                              : 'inherit',
                          color:
                            selectedItem === item.id
                              ? activeGrant &&
                                activeGrant?.grant_source === 'corporate_grant'
                                ? '#426BF0'
                                : '#C67EFF'
                              : 'inherit',
                          fontFamily: fonts.Inter.Medium,
                        }}>
                        {selectedItem == item.id ? (
                          <Box
                            // p={2}
                            bgcolor={
                              activeGrant &&
                                activeGrant?.grant_source === 'corporate_grant'
                                ? '#9135E0'
                                : '#C67EFF'
                            }
                            borderRadius={2}
                            alignItems="center"
                            mr={1}>
                            <ListItemIcon sx={{ minWidth: 'unset' }}>
                              {item.iconactive}
                            </ListItemIcon>
                          </Box>
                        ) : (
                          <ListItemIcon>{item.icon}</ListItemIcon>
                        )}
                        {selectedItem == item.id ? (
                          <Typography
                            variant="body1"
                            sx={{
                              fontFamily: 'InterRegular',
                              fontWeight: 500,
                              fontSize: '16px',
                              lineHeight: '20px',
                              color: '#32174E',
                              letterSpacing: '1%',
                            }}>
                            {item.text}
                          </Typography>
                        ) : (
                          <Typography
                            sx={{
                              fontFamily: 'InterRegular',
                              fontWeight: 500,
                              fontSize: '16px',
                              lineHeight: '20px',
                              color: '#32174E',
                              letterSpacing: '1%',
                            }}
                          >
                            {item.text}
                          </Typography>
                        )}
                        {isDropdownOpen ? <ExpandLess /> : <ExpandMore />}
                      </ListItemButton>
                    </ListItem>
                    <Collapse in={isDropdownOpen} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>
                        {item.submenu?.map((subItem) => (
                          <ListItem
                            key={subItem.id}
                            disablePadding
                            onClick={() => {
                              handleItemClick(subItem.id, subItem.url)
                            }}
                            sx={{
                              paddingLeft: 4,
                              background: theme.palette.grey[100],
                            }}>
                            <ListItemButton
                              sx={{
                                padding: '8px 0px',
                                marginX: 6,
                                borderRadius: 3,
                                maxHeight: '50px',
                                background:
                                  selectedItem === item.id
                                    ? '#9135E0'
                                    : 'inherit',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color:
                                  selectedItem === subItem.id
                                    ? '#9135E0'
                                    : 'inherit',
                              }}>
                              {selectedItem == subItem.id ? (
                                <Typography
                                  sx={{
                                    fontFamily: 'InterRegular',
                                    fontWeight: 500,
                                    fontSize: '16px',
                                    lineHeight: '20px',
                                    color: '#32174E',
                                    letterSpacing: '1%',
                                  }}>
                                  {subItem.text}
                                </Typography>
                              ) : (
                                <Typography
                                  sx={{
                                    fontFamily: 'InterRegular',
                                    fontWeight: 500,
                                    fontSize: '16px',
                                    lineHeight: '20px',
                                    color: '#32174E',
                                    letterSpacing: '1%',
                                  }}
                                >
                                  {subItem.text}
                                </Typography>
                              )}
                            </ListItemButton>
                          </ListItem>
                        ))}
                      </List>
                    </Collapse>
                  </div>
                ) : (

                  index === 3 && ((activeGrant && activeGrant?.grant_source == 'corporate_grant') || (activeGrant?.grant_source.includes('family') && activeGrant?.sku == null)) ? null : (
                    <ListItem
                      key={item.id}
                      disablePadding
                      onClick={() => handleItemClick(item.id, item.url)}
                      sx={{
                        color:
                          selectedItem === item.id
                            ? '#9135E0'
                            : 'inherit',
                      }}>
                      <ListItemButton
                        className={
                          item.id === 'dashboard'
                            ? 'dashboard-sidebar'
                            : item.id === 'profile'
                              ? 'profile-sidebar'
                              : ''
                        }
                        sx={{
                          padding: '8px 0px',
                          marginLeft: 6,
                          marginBottom: 2,
                          marginRight: 5,
                          borderRadius: 3,
                          maxHeight: '50px',
                          background:
                            selectedItem === item.id
                              ? '#9135E0'
                              : 'inherit',
                          color:
                            selectedItem === item.id
                              ? '#FFFFFF'
                              : '#32174E',
                          '&:hover': {
                            background:
                              selectedItem === item.id ? '#9135E0' : 'rgba(239, 237, 253, 0.70))',
                          },
                        }}>
                        {selectedItem == item.id ? (
                          <Box
                            // p={2}
                            bgcolor={'#9135E0'}
                            borderRadius={2}
                            display="flex"
                            alignItems="center"
                            color='#fff'
                            p={1} // Adjust padding a
                            mr={3}>
                            <ListItemIcon sx={{ color: '#fff', minWidth: 'unset' }}>
                              {item.iconactive}
                            </ListItemIcon>
                          </Box>
                        ) : (
                          <ListItemIcon>{item.icon}</ListItemIcon>
                        )}
                        {selectedItem == item.id ? (
                          <Typography
                            variant="body1"
                            sx={{
                              fontFamily: 'InterSemiBold',
                              fontWeight: 600,
                              fontSize: '16px',
                              color: selectedItem === item.id
                                ? '#FFFFFF'
                                : '#32174E',
                            }}>
                            {item.text}
                          </Typography>
                        ) : (
                          <Typography
                            sx={{
                              fontFamily: 'InterRegular',
                              fontWeight: 500,
                              fontSize: '16px',
                              lineHeight: '20px',
                              color: '#32174E',
                              letterSpacing: '1%',
                            }}
                          >
                            {item.text}
                          </Typography>
                        )}
                      </ListItemButton>
                    </ListItem>
                  ))}
              </div>
            ))}
            {!isMobile && (<Box mt={10} position={'absolute'} bottom={10}>  {!grant && (
              <Box sx={styles.subscribeDiv}>
                <Typography sx={styles.subscribeText}>
                  Subscribe to Priwall to remove your personal
                  information from the web
                </Typography>
                <Button
                  sx={styles.subscribeButton}
                  fullWidth
                  onClick={() => navigate('/subscription')}>
                  Subscribe
                </Button>
              </Box>
            )}</Box>)}
            <Box mt={10}>
              {isMobile && (
                <div style={{ paddingLeft: 10 }}>
                  <ListItem key="termscondition">
                    <Link
                      href="https://meprism.com/terms-conditions"
                      sx={styles.linkStyle}>
                      Terms & Conditions
                    </Link>
                  </ListItem>
                  <ListItem key="privacypolicy">
                    <Link
                      href="https://meprism.com/privacy-policy"
                      sx={styles.linkStyle}>
                      Privacy Policy
                    </Link>
                  </ListItem>
                  <ListItem key="signout" onClick={handleLogout}>
                    <Typography variant="body1">Sign Out</Typography>
                  </ListItem>
                </div>
              )}
              {!grant && isMobile && (
                <Box sx={styles.subscribeDiv}>
                  <Typography sx={styles.subscribeText}>
                    Subscribe to Priwall to remove your personal
                    information from the web
                  </Typography>
                  <Button
                    sx={styles.subscribeButton}
                    fullWidth
                    onClick={() => navigate('/subscription')}>
                    Subscribe
                  </Button>
                </Box>
              )}
            </Box>
          </Drawer>
          <Box
            component="main"
            sx={{
              backgroundColor: theme.palette.grey[100],
              zIndex: 1,
              flexGrow: 1,
              backgroundImage: isMobile
                ? activeGrant && activeGrant?.grant_source === 'corporate_grant'
                  ? `url(${backgroundmob})`
                  : `url(${backgroundmobretail})`
                : activeGrant && activeGrant?.grant_source === 'corporate_grant'
                  ? `url(${backgroundretail})`
                  : `url(${backgroundretail})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              height: '100dvh',
              overflow: 'auto',
            }}>

            <Box
              sx={{
                maxWidth: 'xl',
                mx: 'auto',
                my: isMobile ? 2 : 0,
                minHeight: isMobile ? '80dvh' : '100dvh',
                pb: isMobile ? '50px' : 0,
                width: '100%',
              }}>
              <Outlet context={useOutletContext()} />
            </Box>
            {isMobile && (
              <Box
                sx={{
                  width: '100%',
                  position: 'fixed',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  margin: 'auto',
                  zIndex: 9,
                }}>
                <BottomNavigation
                  showLabels
                  value={selectedItem}
                  sx={{
                    height: 84,
                    borderTop: '1px solid #9135E0',
                    zIndex: 100,
                    bgcolor: '#fff',
                    borderTopLeftRadius: '24px',
                    borderTopRightRadius: '24px',
                    overflow: 'hidden',
                    boxShadow: '0px -4px 10px rgba(0, 0, 0, 0.05)',
                    '& .MuiBottomNavigationAction-root': {
                      color: '#615F6B',
                    },
                    '& .MuiBottomNavigationAction-root.Mui-selected': {
                      color: '#9135E0',
                    },
                  }}
                >
                  {sidebarMobItems.map((item) => {
                    if (item.id === 'Subscription' && ((activeGrant && activeGrant?.grant_source == 'corporate_grant') || (activeGrant?.grant_source?.includes('family') && activeGrant?.sku == null))) {
                      return null;
                    }
                    const isActive = selectedItem === item.id;
                    return (
                      <BottomNavigationAction
                        key={item.id}
                        value={item.id}
                        label={item.text}
                        onClick={() => handleItemClick(item.id, item.url, (item as any).external)}
                        id={item.id === 'Chat' ? 'intercom-launcher' : undefined}
                        sx={{
                          minWidth: 0,
                          padding: '12px 0 8px',
                          color: isActive ? '#9135E0' : '#615F6B',
                          '& .MuiBottomNavigationAction-label': {
                            fontFamily: 'InterRegular',
                            fontSize: '12px !important',
                            fontWeight: isActive ? 600 : 400,
                            mt: 0.5,
                            color: isActive ? '#9135E0' : '#615F6B',
                          },
                        }}
                        icon={
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              height: '24px',
                              width: '24px'
                            }}
                          >
                            {isActive ? item.iconactive : item.icon}
                          </Box>
                        }
                      />
                    );
                  })}
                </BottomNavigation>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  )
}
